<template>
  <div>
    <q-card>
      <div class="row ">
        <div class="col-6" style="background: #f2f7f4;">
          <img src="../../assets/otp.png" class="w-100" alt="otp">
        </div>
        <div class="col-6 p-2" style="background: #f2f7f4;">
          <div class="w-100">
            <q-btn color="primary" class="float-right" dense flat icon="close" @click="closeDialog">
              <q-tooltip>Close</q-tooltip>
            </q-btn>
          </div>

          <template v-if="flag1">
            <div><h5>Reset Password</h5></div>
            <div class="py-2 mt-3 mb-3">
              <h6 style="font-size: 16px;">Enter your mobile number</h6>
            </div>
            <div>
              <q-input class="mb-3" label="Enter Mobile Number" mask="##### #####" v-model="mobile"></q-input>

              <q-btn class="pd-btn my-3 mr-2" @click="requestOtp" size="12px" :disabled="mobile.length!==11">
                Request OTP
              </q-btn>
              <q-spinner color="green" size="2em" :thickness="2" v-if="loading"></q-spinner>
            </div>
          </template>

          <template v-if="flag2">
            <div><h5>Verify OTP</h5></div>
            <div class="py-2 mt-3 mb-3">
              <h6 style="font-size: 16px;">Enter the verification code we just sent on your mobile number
                {{ mobile }}.</h6>
            </div>
            <div>
              <q-input class="mb-3" label="Enter OTP" mask="####" v-model="otp"></q-input>
              <q-btn class="pd-btn my-3" @click="verifyOtp" size="12px" :disabled="otp.length!==4||verifyOtpDisabled">Verify OTP</q-btn>
              <q-btn class="btn-resend ml-2 my-3" @click="requestOtp" size="12px">Resend OTP</q-btn>
              <q-spinner color="green" size="2em" :thickness="2" v-if="loading2"></q-spinner>
            </div>
          </template>

          <template v-if="flag3">
            <div><h5>Set Password</h5></div>
            <div class="py-2 mt-3 mb-3">
              <h6 style="font-size: 16px;">Enter the Password you want to set </h6>
            </div>
            <div>
              <q-input class="mb-3" label="New Password" type="password" v-model="newPassword"></q-input>
              <q-input class="mb-3" label="Confirm Password" type="password" v-model="confirmPassword"></q-input>

              <q-btn class="pd-btn my-3 mr-2" @click="resetPassword" size="12px">Reset</q-btn>
              <q-spinner color="green" size="2em" :thickness="2" v-if="loading3"></q-spinner>
            </div>
          </template>

          <template v-if="flag4">
            <!--<div><h5>Set Password</h5></div>-->
            <div class="py-2 mt-5 mb-3 text-center">
              <h6 style="font-size: 16px; font-weight: 800">Your Password has been reset successfully !</h6>
            </div>
          </template>


        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import Constants from '../../Constants/Constant'
import { NetworkCommunicator, setHeader } from '../../plugins/NetworkResourceHandler'

export default {
  name: 'Forgot.vue',
  data: function () {
    return {
      flag1: true,
      flag2: false,
      flag3: false,
      flag4: false,
      mobile: '',
      loading: false,
      loading2: false,
      loading3: false,
      otp: '',
      uniqueId: '',
      newPassword: '',
      confirmPassword: '',
      verifyOtpDisabled: false,
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeForgotPasswordDialog', false)
    },
    async requestOtp () {
      this.loading = true
      let response = await NetworkCommunicator('POST', `${Constants.api_url}forgotPassword/sendOTP`,
          false, { mobile: this.mobile.replace(/ +/g, '') }, {})
      this.loading = false
      if (response.flag) {
        this.$q.notify(response.message)
        this.flag1 = false
        this.flag2 = true
        this.uniqueId = response.data.id
        this.verifyOtpDisabled = false
      } else {
        this.$q.notify(response.message)
      }
    },
    async verifyOtp () {
      this.loading2 = true
      let response = await NetworkCommunicator('POST', `${Constants.api_url}forgotPassword/verifyOtp`,
          false, { otp: this.otp, uniqueId: this.uniqueId }, {})
      this.loading2 = false
      if (response.flag) {
        this.$q.notify(response.message)
        this.flag2 = false
        this.flag3 = true
        localStorage.setItem('token', response.data.token)
        setHeader()
      } else {
        if (response.code === 41) {
          this.$q.notify(response.message) //Invalid OTP
        } else if (response.code === 202) {
          this.$q.notify(response.message) //Maximum Try
          this.otp = ''
          this.uniqueId = ''
          this.verifyOtpDisabled = true
        } else {
          this.$q.notify(response.message)
        }
      }
    },
    async resetPassword () {
      if (this.newPassword !== this.confirmPassword) {
        this.$q.notify('Password entered not matched with confirm password')
        return
      }

      this.loading3 = true
      let response = await NetworkCommunicator('POST', `${Constants.api_url}forgotPassword`,
          false, { password: this.newPassword }, {})
      this.loading3 = false
      if (response.flag) {
        this.$q.notify(response.message)
        this.flag3 = false
        this.flag4 = true
      } else {
        this.$q.notify(response.message)
      }
    },
  },
}
</script>

<style scoped>

</style>
